module.exports = __webpack_public_path__ + "img/Tian_Xu.07952957.png";